module.exports = __webpack_public_path__ + "img/card-background.6355e1c1.png";